import { createFileRoute } from "@tanstack/react-router"
import { TenantRoute } from "@/tenant"

export const Route = createFileRoute("/(user)/(tenantBc)")({
  component: RouteComponent,
})

function RouteComponent() {
  return <TenantRoute tenantSlug={undefined} />
}
